import IntervalTree from 'interval-tree2';
import Promise from 'promise-polyfill';
var moment = require('moment');

var padStart = require('string.prototype.padstart'); 
padStart.shim();

/**
 * helper functions
 * @module util
 */
export default {

    /**
     * returns the id of an event
     * @param {object} eventObject - the event data for which an id is required
     * @returns {string} the id of the event object
     */
    getEventId(eventObject) {
        return eventObject['id'];
    },


    /**
     * combines a date and time to create a single moment
     * @param {string} date - the date, in the format specified later
     * @param {string} time - the time, in the format specified later
     * @param {string} dateFormat - a string to use for formatting the date using moment
     * @param {string} timeFormat - a string to use for formatting the time using moment
     * @returns {moment} the dates combined to create a single moment object
     */
    getCombinedDateTimeMoment(date, time, dateFormat, timeFormat) {
        return moment(
            `${date} ${time}`,
            `${dateFormat} ${timeFormat}`
        )
    },


    /**
     * checks whether an object is empty
     * @param {object} object - the object the check
     * @returns {boolean} whether the object is empty
     */
    objectIsEmpty(object) {
        return Object.keys(object).length === 0;
    },

    /**
     * gets Promise constructor
     * @desc There are too many ways to do promises in js, but 
           having a function to get a Promise constructor means
           we can just return a constructor which will provide
           a common interface.
     * @example
     * import Util from 'util.js'
     * var Promise = Util.getPromise();
     * var aPromise = new Promise((resolve, reject) => { ... });
     * @returns {function} a function to be used to create a promise
     */
    getPromise() {
        return Promise;
    },

    /**
     * returns an empty promise
     * @returns {promise}
     */
    getEmptyPromise() {
        return new Promise((resolve, reject) => {
            resolve(true);
        });
    },


    /**
     * converts a module into two numbers, which represent their
     * start and end dates
     * @param {object} module_ - the module for which data is required
     * @param {string} dateFormat - a string to use for formatting the date using moment
     * @param {string} timeFormat - a string to use for formatting the time using moment
     * @returns {object} has keys 'start' and 'end', each of which is a number
     */
    getModulesCombinedStartEndDateTimes(module_, dateFormat, timeFormat) {
        let compositeStart = this.getCombinedDateTimeMoment(
            module_['start_date'],
            module_['start_time'],
            dateFormat,
            timeFormat
        );

        let compositeEnd = this.getCombinedDateTimeMoment(
            module_['end_date'],
            module_['end_time'],
            dateFormat,
            timeFormat
        );


        return {
            start: compositeStart.unix(),
            end: compositeEnd.unix()
        }

    },


    /**
     * returns a constructor for an interval tree
     * @returns {function} a constructor for an interval tree
     */
    getIntervalTree() {
        return IntervalTree;
    },
}



// WEBPACK FOOTER //
// ./src/util.js